import script from "./SiteVisitRequestDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SiteVisitRequestDialog.vue?vue&type=script&setup=true&lang=ts"

import "./SiteVisitRequestDialog.vue?vue&type=style&index=0&id=bc521a10&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc521a10"]])

export default __exports__